<div class="flex-container">
    <div class="center">
        <mat-icon
            svgIcon="hub_star_filled"
            class="star"
        >
        </mat-icon>
    </div>
    <div class="row align-items-center snackbar-content">
        <div *ngIf="snackBarAction === favoriteAction.Favorite" class="col-md-12 text">
            {{consts.LABEL_FAVORITE_ACTION}} "<a [href]="snackBarData.link" target="_blank" class="link">{{snackBarData.name}}</a>".
            {{consts.LABEL_FAVORITE_ACTION_VIEWALL}} <a class="link" (click)="navigateToFavoritesList()">{{consts.LABEL_FAVORITES_LINK}}</a>
        </div>
        <div *ngIf="snackBarAction === favoriteAction.FavoriteMany" class="col-md-12 text">
            {{consts.LABEL_FAVORITE_ACTION}} "<a [href]="snackBarData[0].link" target="_blank" class="link">{{snackBarData[0].name}}</a>"
            <ng-container *ngIf="snackBarData.length > 1"> {{consts.LABEL_FAVORITE_MANY_ACTION_AND}} {{snackBarData.length - 1}} {{consts.LABEL_FAVORITE_MANY_ACTION_MORE}}</ng-container>
        </div>
        <div *ngIf="snackBarAction === favoriteAction.Unfavorite" class="col-md-12 text">
            {{consts.LABEL_UNFAVORITE_ACTION}} "<a [href]="snackBarData.link" target="_blank" class="link">{{snackBarData.name}}</a>".
        </div>
        <div *ngIf="snackBarAction === favoriteAction.Managefavorite" class="col-md-12 text">
            {{snackBarMessage}} "<a [href]="snackBarData.link" target="_blank" class="link">{{snackBarData.name}}</a>".
        </div>
    </div>
    <div class="center">
        <mat-icon
            (click)="snackBarRef.dismiss()"
            class="close"
            svgIcon="hub_close"
        >
        </mat-icon>
    </div>
</div>
